import {
	GetBannedPlayerRequest,
	GetBannedPlayerResponse,
} from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getBannedPlayerList } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetBannedPlayer(
	payload: GetBannedPlayerRequest,
	props?: UseBaseQueryOptions<GetBannedPlayerResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetBannedPlayerList, payload],
		queryFn: () => getBannedPlayerList(payload),
		...props,
	})
}
